module.exports = __webpack_public_path__ + "static/media/logo-text-roundedtext-rose.2c0f849a.png";